import BaseService from "./BaseService";
import CustomerModel from "../core/models/Customer";
// import { mockRequest } from "./MockService";
import { LocalCache, SessionCache } from "../helpers/cache";
import sortBy from "lodash/sortBy";
import { isArrayValid } from "../helpers/utility";
import { IInstallation } from "../core/contracts/IInstallation";
import User from "../core/models/User";
import UserService from "./UserService";

export default class CustomerService extends BaseService {
  async fetchAll(): Promise<CustomerModel[]> {
    try {
      const cache = new LocalCache();

      let useCustomers: {
        customer_id: string;
        customer_name: string;
        installationIds: string[];
      }[] = [];

      let cachedUser: User | null = cache.get("user");

      //FIXME: im not sure if im allowed to do this
      // if (!cachedUser) {
      //   const requestUserData = await new UserService().fetch();

      //   if (requestUserData) {
      //     cachedUser = requestUserData;
      //   }
      // }

      if (cachedUser && isArrayValid(cachedUser.installationGroup)) {
        const useInstallationGroups = cachedUser.installationGroup?.filter((x) =>
          isArrayValid(x.installationList)
        );
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const newCustomers = useInstallationGroups!.map((x) => {
          return {
            customer_id: x.id.toString(),
            customer_name: x.name || "",
            installationIds: x.installationList.map((x) => x?.installationId?.toString() ?? ""),
          };
        });

        useCustomers = newCustomers;
      }

      const idsToRequest = useCustomers.flatMap((c) => {
        return c.installationIds.map((id) => {
          return { installation_id: id };
        });
      });
      const InstallationData = await new BaseService().post<
        { installations: IInstallation[] },
        { installation_id: string }[]
      >("/installation/", idsToRequest);

      let customerRet: CustomerModel[] = useCustomers.map((customer) => {
        const { customer_id, customer_name } = customer;

        return {
          customer_id,
          customer_name,
          installations:
            InstallationData?.installations?.filter((x) =>
              customer.installationIds.includes(x.installation_id)
            ) || [],
        };
      });

      customerRet = sortBy(customerRet, "customer_name")?.map((x) => {
        return { ...x, installations: sortBy(x.installations, "product_code") };
      });

      const storage = new SessionCache();
      storage.set("customers", customerRet);
      return customerRet;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("CustomerService -> doLogin -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchAllCacheable(): Promise<CustomerModel[]> {
    try {
      const storage = new SessionCache();
      const cachedClients: CustomerModel[] | null = storage.get("customers");

      if (isArrayValid(cachedClients)) {
        // eslint-disable-next-line no-console
        console.info("successfully retrieved customers from cache!");
        // eslint-disable-next-line no-console
        console.log("CustomerService -> cachedClients", cachedClients);
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return cachedClients!;
      }

      return new CustomerService().fetchAll();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("CustomerService -> fetchAllCacheable -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchClients(): Promise<string[]> {
    try {
      const APIResponse = await new BaseService().get<string[]>(
        `/Customer/ListarClientesDistintos`
      );

      return APIResponse;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("CustomerService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }

  async fetchFilterClients(filter: string): Promise<string[]> {
    try {
      let endpoint = '/Customer/ListarClientesDistintosFiltrados';
      endpoint += filter != null && filter != "Todos" ? `?filtro=${filter}` : "";
      const APIResponse = await new BaseService().get<string[]>(
        endpoint
      );

      return APIResponse;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("CustomerService -> fetch -> error", error);
      return new Promise((_, rej) => rej(error));
    }
  }
}
